import { getAnnouncements } from './user_helpers';

export const getAnnouncementByType = (user, type) => {
  const announcements = getAnnouncements(user);
  return announcements.find(announcement => announcement.type === type);
};
